<article class="solution-option" [class.selected]="selected()" [class.current]="solution().isCurrent"
  [class.disabled]="!isSelectable()" (click)="onSelect()" (keydown.enter)="onSelect()"
  (keydown.space)="onSelect(); $event.preventDefault()" [attr.role]="isSelectable() ? 'button' : null"
  [attr.tabindex]="isSelectable() ? 0 : null" [attr.aria-pressed]="isSelectable() ? selected() : null"
  [attr.aria-disabled]="isSelectable() ? null : true">

  <div class="solution-info">
    <div class="solution-icon" aria-hidden="true">
      @if (logoUrl()) {
      <img class="solution-logo" [src]="logoUrl()" [alt]="solution().name" (error)="onLogoError()">
      } @else {
      <mat-icon>{{ solution().iconName }}</mat-icon>
      }
    </div>

    <div class="solution-texts">
      <h3 class="solution-name">{{ solution().name }}</h3>
      <span class="solution-badge">{{ badgeLabel() | translate }}</span>
    </div>
  </div>

  <div class="solution-selection-indicator" [class.visible]="selected()" aria-hidden="true">
    <mat-icon>chevron_right</mat-icon>
  </div>
</article>
